<h3>
    Unbestätigte UUIDs
    <mat-icon
      svgIcon="innogy_picto_speech-bubble_exclamationmark"
      aria-hidden="false"
      [attr.aria-label]="tooltipText"
      [matTooltip]="tooltipText"
      matTooltipPosition="above"
      matTooltipClass="multiline-tooltip"
    >
    </mat-icon>
</h3>
<mat-card>
    <mat-card-content>
        <table mat-table [dataSource]="unbestaetigteUuids()" data-qa="unbestaetigte-uuid-table">
            <ng-container matColumnDef="netzbetreiberName">
                <th mat-header-cell *matHeaderCellDef>Betroffene STW (Top 10) </th>
                <td mat-cell *matCellDef="let element"> {{element.netzbetreiberName}} </td>
            </ng-container>
            <ng-container matColumnDef="stadtwerkeId">
                <th mat-header-cell *matHeaderCellDef> STW-ID </th>
                <td mat-cell *matCellDef="let element"> {{element.stadtwerkeId}} </td>
            </ng-container>
            <ng-container matColumnDef="countUnbestaetigteUuids">
                <th mat-header-cell *matHeaderCellDef> Anzahl IDs </th>
                <td mat-cell *matCellDef="let element"> {{element.countUnbestaetigteUuids}} </td>
            </ng-container>
            <ng-container matColumnDef="lastBestaetigtDate">
                <th mat-header-cell *matHeaderCellDef> Zuletzt bestätigt </th>
                <td mat-cell *matCellDef="let element">
                    @if (element.lastBestaetigtDate) {
                        <td>{{element.lastBestaetigtDate | date:"dd.MM.yyyy" }} </td>
                    } @else {
                        <td>-</td>
                    }
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </mat-card-content>
</mat-card>
